<!--仓库管理-出库验收差异 -->
<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" size="medium">
        <el-form-item label="订单日期：">
          <el-date-picker v-model="searchForm.SEND_DAY" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-input v-model="searchForm.PRODUCT_CODE" placeholder="请输入产品编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入产品名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="差异类型：">
          <el-select v-model="searchForm.差异类型" placeholder="请选择差异类型" @change="筛选()">
            <el-option v-for="item in 差异类型列表" :key="item.ID" :label="item.LABEL" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <tooltip-button buttonType="primary" button-text="筛选" @click="筛选()" :disabled="产品编码填写正确" :loading="获取数据中"
            tip-content="请填写正确的产品编码">
          </tooltip-button>
        </el-form-item>
        <el-form-item>
          <download-json-to-excel ref="download" type="primary" plain text="导出" @click="导出()" :disabled="产品编码填写正确"
            :loading="获取数据中" tip-content="请填写正确的产品编码" :header="导出表头" fileName="出库验收差异.xlsx">
          </download-json-to-excel>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table border stripe :data="tableData" @selection-change="(val) => 勾选产品(val)">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="SEND_DAY" label="订单日期" width="100"></el-table-column>
        <el-table-column prop="DELIVER_DAY" label="出库日期" width="100"></el-table-column>
        <el-table-column prop="ORDER_ID" label="销售订单ID" width="100"></el-table-column>
        <el-table-column prop="TC_NAME" label="客户"></el-table-column>
        <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
        <el-table-column prop="DK_NAME" label="档口"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
        <el-table-column prop="DELIVER_COUNT" label="出库数量"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
        <el-table-column prop="DIFFERENCE_COUNT" label="差异（出库－实收）" width="150"></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="pagination_box" style="text-align: right">
        <el-pagination @current-change="获取列表数据()" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
      <tooltip-button v-if="!searchForm.差异类型" button-type="primary" @click="一键退库及报损()" :button-loading="处理数据中" button-text="一键退库及报损"
        :disabled="Boolean(勾选产品列表.length)" tip-content="请先勾选产品">
      </tooltip-button>
    </el-row>
  </div>
</template>
<script>
import { 获取出库验收差异数据, 产品列表退库且报损 } from 'api/warehouseManager';
import date from '@/assets/common/date';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      searchForm: {
        SEND_DAY: [date(new Date(), '%F'), date(new Date(), '%F')],
        差异类型: 0,
      },
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      差异类型列表: [{ ID: 0, LABEL: '出库>实收' }, { ID: 1, LABEL: '出库<实收' }],
      勾选产品列表: [],
      获取数据中: false,
      处理数据中: false,
      导出表头: {
        SEND_DAY: '订单日期',
        DELIVER_DAY: '出库日期',
        ORDER_ID: '销售订单ID',
        TC_NAME: '客户',
        PROJECT_NAME: '项目点',
        DK_NAME: '档口',
        PRODUCT_CODE: '产品编码',
        PRODUCT_NAME: '产品名称',
        TYPE_UNIT: '单位',
        PRODUCT_COUNT: '订购数量',
        DELIVER_COUNT: '出库数量',
        REAL_COUNT: '实收数量',
        DIFFERENCE_COUNT: '数量差距',
      },
    };
  },
  async mounted() {
    if (Object.keys(this.出库验收差异筛选条件).length) {
      this.currentPage = this.出库验收差异筛选条件.CURRENT_PAGE;
      this.searchForm = this.出库验收差异筛选条件.CONDITION;
    }
    await this.筛选();
    this.获取列表数据();
  },
  computed: {
    出库验收差异筛选条件() {
      return this.$store.state.出库验收差异筛选条件;
    },
    产品编码填写正确() {
      return validation.产品编码验证(this.searchForm.PRODUCT_CODE);
    },
  },
  methods: {
    表格展示数据() {
      let data = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize - 1);
      if (!data.length && this.currentPage > 1) {
        this.currentPage--;
        data = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize - 1);
      }
      this.tableData = data;
    },
    勾选产品(val) {
      this.勾选产品列表 = val;
    },
    导出() {
      this.获取数据中 = true;
      const params = {
        SEND_DAY_START: this.searchForm.SEND_DAY[0],
        SEND_DAY_END: this.searchForm.SEND_DAY[1],
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      获取出库验收差异数据(params).then((res) => {
        const data = res.filter(({ RECORD_TYPE }) => RECORD_TYPE == this.searchForm.差异类型);
        if (data.length > 0) {
          this.$refs.download.download(data.map(({
            SEND_DAY, DELIVER_DAY, ORDER_ID, TC_NAME, PROJECT_NAME, DK_NAME, PRODUCT_CODE, PRODUCT_NAME, TYPE_UNIT,
            PRODUCT_COUNT, DELIVER_COUNT, REAL_COUNT, DIFFERENCE_COUNT,
          }) => ({
            SEND_DAY,
            DELIVER_DAY,
            ORDER_ID,
            TC_NAME,
            PROJECT_NAME,
            DK_NAME,
            PRODUCT_CODE: PRODUCT_CODE.toString(),
            PRODUCT_NAME,
            TYPE_UNIT,
            PRODUCT_COUNT,
            DELIVER_COUNT,
            REAL_COUNT,
            DIFFERENCE_COUNT,
          })), [10, 10, 10, 20, 20, 20, 20, 20, 5, 10, 10, 10, 10]);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.获取数据中 = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.获取数据中 = false;
      });
    },
    筛选() {
      this.currentPage = 1;
      this.获取列表数据();
    },
    获取列表数据() {
      this.获取数据中 = true;
      const params = {
        SEND_DAY_START: this.searchForm.SEND_DAY[0],
        SEND_DAY_END: this.searchForm.SEND_DAY[1],
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      获取出库验收差异数据(params).then((res) => {
        this.allData = res.filter(({ RECORD_TYPE }) => RECORD_TYPE == this.searchForm.差异类型);
        this.totalCount = this.allData.length;
        if (res.length > 0) {
          this.$store.dispatch('保存出库验收差异筛选条件', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        }
        this.表格展示数据();
        this.获取数据中 = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.tableData = [];
        this.获取数据中 = false;
      });
    },
    一键退库及报损() {
      this.处理数据中 = true;
      const params = {
        RETURN_ORDER_LIST: this.勾选产品列表.map((item) => ({
          ORDER_ID: item.ORDER_ID,
          DEATIL_ID: item.DETAIL_ID,
          PRODUCT_CODE: item.PRODUCT_CODE,
          RETURN_COUNT: item.DIFFERENCE_COUNT,
          TYPE_UNIT: item.TYPE_UNIT,
        })),
      };
      产品列表退库且报损(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.获取列表数据();
        this.处理数据中 = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.处理数据中 = false;
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/warehouseManage/differenceBetweenOutboundAndAcceptance.vue